export const SESSION_TYPE = {
    BLOCKED: 'BLOCKED',
    TEACHING: 'TEACHING',
    BREAK: 'BREAK',
    TRAINING: 'TRAINING',
    CHECK_IN: 'CHECK_IN',
};